<template>
    <div class="feedbackboard-phonetic-consonant">
        <div class="feedbackboard-phonetic-consonant__feature-type">
            <span class="feedbackboard-phonetic-consonant__feature-label">DEĞİŞKE ÖZELLİĞİ</span>
            <div class="feedbackboard-phonetic-consonant__feature-options">
                <BtnOptionFeedback
                    :class="{
                        'btn-option-feedback--skipped': feedbackVariant.answerValue === ''
                    }"
                    :optionText="$t('consonant.variant.' + feedbackVariant.correctValue)" />
                <BtnOptionFeedback
                    v-if="feedbackVariant.answerValue !== feedbackVariant.correctValue
                        && feedbackVariant.answerValue !== ''"
                    class="btn-option-feedback--incorrect"
                    :optionText="$t('consonant.variant.' + feedbackVariant.answerValue)" />
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionFeedback    from '@/components/BtnOptionFeedback.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionFeedback,
        },

        computed: {
            feedbackVariant(){
                return this.$store.state.feedbackData.variant;
            }
        },
    };
</script>

<style scoped src="@/css/components/feedbackboard-phonetic-consonant.css"></style>